import {Component, Input, OnInit} from '@angular/core';
import {ListWorkwavesScheduleComponent} from "../list.component";

@Component({
  selector: 'title-list-workwaves-schedule',
  templateUrl: './list-title.component.html',
  styleUrls: ['./list-title.component.scss']
})
export class TitleListWorkwavesScheduleComponent implements OnInit {

  @Input() filters: any;
  @Input() filterOptions: any;

  constructor(
    private listComponent: ListWorkwavesScheduleComponent
  ) {}

  ngOnInit() {}

  applyFilters(event, column: string){
    this.listComponent.applyFilters(event, column);
  }

  orderBy(column: string){
    this.listComponent.orderBy(column);
  }

}
